import * as React from "react";
import { forwardRef } from "react";
const SvgLingoflowBlack = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 1200, height: 1200, viewBox: "0 0 1200 1200", id: "svg8", "sodipodi:docname": "lingoflow_no_padding_no_bg.svg", "inkscape:version": "1.3.2 (091e20e, 2023-11-25, custom)", "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape", "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd", xmlns: "http://www.w3.org/2000/svg", "xmlns:svg": "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("defs", { id: "defs8" }), /* @__PURE__ */ React.createElement("sodipodi:namedview", { id: "namedview8", pagecolor: "#ffffff", bordercolor: "#000000", borderopacity: 0.25, "inkscape:showpageshadow": 2, "inkscape:pageopacity": 0, "inkscape:pagecheckerboard": 0, "inkscape:deskcolor": "#d1d1d1", "inkscape:zoom": 0.47906484, "inkscape:cx": 836.00374, "inkscape:cy": 696.14793, "inkscape:window-width": 1920, "inkscape:window-height": 1009, "inkscape:window-x": -8, "inkscape:window-y": -8, "inkscape:window-maximized": 1, "inkscape:current-layer": "svg8" }), /* @__PURE__ */ React.createElement("g", { id: "c5e834d6-62dd-464d-9904-a7fdc7374e3a", style: {
  fill: "none"
} }, /* @__PURE__ */ React.createElement("rect", { style: {
  opacity: 1,
  fill: "none",
  fillRule: "nonzero",
  stroke: "#c1c1c1",
  strokeWidth: 0,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0
}, x: -600, y: -600, rx: 0, ry: 0, width: 1200, height: 1200, transform: "translate(600,600)", id: "rect1" })), /* @__PURE__ */ React.createElement("g", { id: "dd123897-3fc2-4a4a-bf77-953f1e0e0e43" }, /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  fill: "#727272",
  fillRule: "nonzero",
  stroke: "#727272",
  strokeWidth: 0,
  strokeLinecap: "butt",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0
}, vectorEffect: "non-scaling-stroke", d: "", strokeLinecap: "round", id: "path1" })), /* @__PURE__ */ React.createElement("g", { id: "bbe28318-c7dc-452e-992a-133e181b27f3" }, /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  fill: "#727272",
  fillRule: "nonzero",
  stroke: "#c1c1c1",
  strokeWidth: 0,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0
}, d: "", strokeLinecap: "round", id: "path3" })), /* @__PURE__ */ React.createElement("g", { id: "15049ae9-9a7f-42c8-bee4-70fcd4c87894" }, /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  fill: "#c1c1c1",
  fillRule: "nonzero",
  stroke: "#c1c1c1",
  strokeWidth: 0,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0
}, d: "", strokeLinecap: "round", id: "path4" })), /* @__PURE__ */ React.createElement("g", { id: "3f44b5e3-3d63-4b17-be73-b6fe37d4bd23" }, /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  fill: "#727272",
  fillRule: "nonzero",
  stroke: "#727272",
  strokeWidth: 0,
  strokeLinecap: "butt",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0
}, vectorEffect: "non-scaling-stroke", d: "", strokeLinecap: "round", id: "path5" })), /* @__PURE__ */ React.createElement("g", { id: "g8", transform: "matrix(1.8318751,0,0,1.3649041,-490.15848,-218.94251)" }, /* @__PURE__ */ React.createElement("g", { id: "2d435742-7d2e-433d-8ac9-54cb6f8d22da" }, /* @__PURE__ */ React.createElement("g", { id: "g2" }, /* @__PURE__ */ React.createElement("g", { id: "95db8ddc-6c1f-403b-b756-bcc2290faf97" }, /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  fill: "#000000",
  fillRule: "nonzero",
  stroke: "#c1c1c1",
  strokeWidth: 0,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0
}, d: "m 467.22247,951.09031 h 317.4 v 72.21999 h -406.18 V 353.55031 h 88.78 z", strokeLinecap: "round", id: "path2" })))), /* @__PURE__ */ React.createElement("g", { id: "27f801b1-a77e-4e23-ae28-585763faffc3" }, /* @__PURE__ */ React.createElement("g", { id: "g6" }, /* @__PURE__ */ React.createElement("g", { id: "ec61a7ca-7359-4a2d-ae72-5b2ca28a37c6" }, /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  fill: "#000000",
  fillRule: "nonzero",
  stroke: "#c1c1c1",
  strokeWidth: 0,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0
}, d: "m 800,562.45 -129.46,3.47 V 832.5 L 561.11,909.78 V 257.44 L 800,176.69 v 108.88 l -129.46,3.47 V 457.5 L 800,454.03 Z", strokeLinecap: "round", id: "path6" }))))), /* @__PURE__ */ React.createElement("g", { id: "319fe959-fd34-4234-927d-15b25a835f1a" }, /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  fill: "#727272",
  fillRule: "nonzero",
  stroke: "#c1c1c1",
  strokeWidth: 0,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0
}, d: "", strokeLinecap: "round", id: "path7" })), /* @__PURE__ */ React.createElement("g", { id: "4cb23ec5-c135-4f4b-8de2-751177e6e925" }, /* @__PURE__ */ React.createElement("path", { style: {
  opacity: 1,
  fill: "#c1c1c1",
  fillRule: "nonzero",
  stroke: "#c1c1c1",
  strokeWidth: 0,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0
}, d: "", strokeLinecap: "round", id: "path8" })));
const ForwardRef = forwardRef(SvgLingoflowBlack);
export default ForwardRef;
